module.exports = __webpack_public_path__ + "1875ae5f5f0168f2f2c604dbfb29e1a5.MP3";